import { createContext, useContext as reactUseContext } from 'react';
function createOptionalContext(displayName) {
    const context = createContext(undefined);
    if (displayName) {
        context.displayName = displayName;
    }
    function useContext() {
        const reactContext = reactUseContext(context);
        if (!reactContext) {
            throw new Error(`[Component Context]: Context ${context.displayName} is not provided.`);
        }
        return reactContext;
    }
    function useOptionalContext() {
        return reactUseContext(context);
    }
    return [context, context.Consumer, context.Provider, useContext, useOptionalContext];
}
export { createOptionalContext, };
//# sourceMappingURL=create-optional-context.js.map